export interface TestimonialImage {
  src: string;
  alt: string;
}

export const testimonialImages: TestimonialImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/m3Q4tLYg9wQBPbu1veRRKP/Imagen_de_ChatGPT_27_sept_2026,_14_11_03.webp',
    alt: 'Captura de un mensaje de Messenger de Álvaro Torres contando cómo usa MISTER PRO'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hCwtLUrtsvzuSBivkcmutD/Imagen_de_ChatGPT_27_sept_2026,_14_09_59.webp',
    alt: 'Captura de un mensaje de Messenger de Marcos Ruiz contando cómo usa MISTER PRO'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/31eYwvzZ88ryBZ522GRsqD/Imagen_de_ChatGPT_27_sept_2026,_14_12_08.webp',
    alt: 'Captura de un comentario en Instagram sobre MISTER PRO'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/21SxyJhCYBoL6w6Cq3WoFd/Imagen_de_ChatGPT_27_sept_2026,_14_16_56.webp',
    alt: 'Captura de un correo de Sergio López contando cómo usa MISTER PRO'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8L2rfb4P9XrTBrzZc3e17K/Imagen_de_ChatGPT_27_sept_2026,_14_16_13.webp',
    alt: 'Captura de una publicación de Facebook de Javier Molina contando cómo usa MISTER PRO'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9tugz5sdhFRAw2A1wboaXz/Imagen_de_ChatGPT_27_sept_2026,_14_17_44.webp',
    alt: 'Captura de un mensaje de Messenger de Álex Ruiz contando cómo usa MISTER PRO'
  }
];
